import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitojalgaoncabbooking() {



    const cardData = {

keyword: "Mumbai to Jalgaon Cab Booking / Dhule",

headingDescription:
    "Mumbai Airport Cab offers safe, comfortable, and reliable Mumbai to Jalgaon and Dhule Cab Booking services for business travelers, families, pilgrims, tourists, and outstation journeys. We provide well-maintained Sedan, SUV, Innova Crysta, Ertiga, Tempo Traveller, Luxury Urbania, and Mini Bus options with experienced chauffeurs for a smooth long-distance journey across Maharashtra. With doorstep pickup across Mumbai, Mumbai Airport transfers, one-way and round-trip cab bookings, flexible travel schedules, customized sightseeing plans, 24/7 customer support, and transparent pricing, we ensure a hassle-free travel experience to Jalgaon, Dhule, and nearby tourist, historical, and religious destinations.",

topPlaces: [
    {
        title: "Ajanta Caves",
        description:
            "Ajanta Caves, a UNESCO World Heritage Site near Jalgaon, are among India's most celebrated historical monuments. The ancient Buddhist rock-cut caves are adorned with intricate sculptures, paintings, and monasteries dating back over two thousand years. Visitors from across the world come to admire their artistic brilliance, spiritual significance, and archaeological importance, making Ajanta a must-visit destination during a Mumbai to Jalgaon cab journey."
    },
    {
        title: "Ellora Caves",
        description:
            "Ellora Caves are one of Maharashtra's greatest architectural treasures and can be conveniently explored during an extended Jalgaon or Dhule trip. The cave complex features Buddhist, Hindu, and Jain monuments, including the magnificent Kailasa Temple carved from a single rock. The UNESCO World Heritage Site attracts history lovers, pilgrims, and architecture enthusiasts throughout the year."
    },
    {
        title: "Shri Muktainagar",
        description:
            "Muktainagar is a sacred destination associated with Saint Muktabai, the younger sister of Sant Dnyaneshwar. Devotees visit the ancient temples and spiritual sites to seek blessings and learn about Maharashtra's rich Bhakti tradition. The peaceful atmosphere and religious importance make it a significant pilgrimage stop in the Jalgaon region."
    },
    {
        title: "Gandhi Research Foundation",
        description:
            "Located in Jalgaon, the Gandhi Research Foundation is dedicated to preserving the life, teachings, and values of Mahatma Gandhi. The modern museum, library, and educational exhibits provide valuable insights into India's freedom movement and Gandhian philosophy. Visitors enjoy an informative and inspiring experience while exploring this cultural institution."
    },
    {
        title: "Mehrun Lake",
        description:
            "Mehrun Lake is one of Jalgaon's most popular recreational attractions, offering a peaceful environment surrounded by greenery. Families and tourists visit the lake for evening walks, bird watching, boating, and relaxation. The scenic setting and calm atmosphere make it an ideal destination for spending quality time during a Jalgaon visit."
    },
    {
        title: "Laling Fort",
        description:
            "Laling Fort near Dhule is a historic hill fort believed to date back several centuries and offers panoramic views of the surrounding plains. The fort features ancient gateways, stone structures, and trekking trails that attract history enthusiasts and adventure lovers. Its strategic location and historical significance make it a fascinating destination."
    },
    {
        title: "Songir Fort",
        description:
            "Songir Fort is an ancient fort situated near Dhule and is known for its impressive architecture and historical importance. The fort once guarded important trade routes and still preserves remnants of its defensive structures. Visitors enjoy exploring the ruins while learning about the rich history of the Khandesh region."
    },
    {
        title: "Unapdev Hot Water Springs",
        description:
            "Unapdev Hot Water Springs is a natural attraction near Jalgaon, famous for its warm water flowing throughout the year. Surrounded by green hills and a peaceful environment, the springs are considered sacred by many visitors. The site is ideal for relaxation, nature appreciation, and enjoying a refreshing break during the journey."
    },
    {
        title: "Ekvira Devi Temple, Dhule",
        description:
            "Ekvira Devi Temple is a revered religious destination in the Dhule region and attracts devotees seeking blessings and spiritual peace. The temple's traditional architecture and devotional atmosphere create a memorable experience for pilgrims and visitors alike. Festivals and special celebrations draw large gatherings throughout the year."
    },
    {
        title: "Toranmal Hill Station",
        description:
            "Toranmal is a beautiful hill station accessible from the Khandesh region and is known for its cool climate, scenic valleys, lakes, waterfalls, and ancient temples. Attractions such as Yashavant Lake, Lotus Lake, and Gorakhnath Temple make it a favorite destination for nature lovers and families. The picturesque landscapes provide a refreshing conclusion to a Mumbai to Jalgaon and Dhule cab journey."
    }
],



services: [
{
name: "Mumbai to Jalgaon Cab Booking",
description: "Mumbai Airport Cab offers Mumbai to Jalgaon Cab Booking service for safe, comfortable, and affordable long-distance travel across Maharashtra. Whether you are travelling for business, family visits, tourism, educational trips, religious journeys, or corporate travel, we provide well-maintained AC Sedan, Ertiga, Innova Crysta, Kia Carens, SUV, Tempo Traveller, and luxury vehicles. Our professional chauffeurs ensure a smooth journey with doorstep pickup, flexible travel schedules, one way and round trip options, transparent pricing, and 24x7 booking support. We provide convenient pickups from Mumbai City, Mumbai Airport, Navi Mumbai, Thane, and surrounding areas with customized travel plans designed for individuals, families, and groups seeking a reliable Mumbai to Jalgaon travel experience."
},
{
name: "Mumbai to Jalgaon Cab",
description: "Book Mumbai to Jalgaon Cab with Mumbai Airport Cab for comfortable and reliable travel. Our clean AC vehicles, experienced chauffeurs, affordable fares, and flexible pickup options ensure a safe journey for families, business travellers, and groups."
},
{
name: "Mumbai to Jalgaon Taxi",
description: "Mumbai Airport Cab provides Mumbai to Jalgaon Taxi service with professional drivers, premium vehicles, doorstep pickup, and convenient one way and round trip travel options."
},
{
name: "Mumbai to Jalgaon Taxi Fare",
description: "Get affordable Mumbai to Jalgaon Taxi Fare with Mumbai Airport Cab. We offer transparent pricing, multiple vehicle choices, and economical travel packages without hidden charges."
},
{
name: "Mumbai to Jalgaon Cab Fare",
description: "Mumbai Airport Cab offers competitive Mumbai to Jalgaon Cab Fare with dependable service, comfortable vehicles, experienced chauffeurs, and flexible travel schedules."
},
{
name: "Cab from Mumbai to Jalgaon",
description: "Choose a Cab from Mumbai to Jalgaon with Mumbai Airport Cab and enjoy safe, convenient, and comfortable long-distance travel with premium AC vehicles."
},
{
name: "Mumbai to Jalgaon Car Rental",
description: "Book Mumbai to Jalgaon Car Rental with chauffeur-driven Sedan, Ertiga, Innova Crysta, SUV, and luxury vehicles for flexible and comfortable travel."
},
{
name: "Mumbai to Jalgaon One Way Cab",
description: "Travel conveniently with Mumbai to Jalgaon One Way Cab service featuring fixed pricing, experienced chauffeurs, AC vehicles, and doorstep pickup and drop."
},
{
name: "Mumbai to Jalgaon Round Trip Cab",
description: "Mumbai Airport Cab offers Mumbai to Jalgaon Round Trip Cab packages for family visits, business travel, sightseeing, and multi-day journeys."
},
{
name: "Mumbai to Jalgaon Outstation Cab",
description: "Book Mumbai to Jalgaon Outstation Cab for reliable long-distance transportation with premium vehicles, affordable fares, and customized travel plans."
},
{
name: "Mumbai to Jalgaon Taxi Service",
description: "Mumbai Airport Cab provides Mumbai to Jalgaon Taxi Service with safe transportation, clean AC vehicles, professional drivers, and convenient booking facilities."
},
{
name: "Mumbai to Jalgaon SUV Cab",
description: "Choose Mumbai to Jalgaon SUV Cab for spacious and comfortable travel with premium interiors, ample luggage space, and reliable chauffeur service."
},
{
name: "Mumbai to Jalgaon Innova Cab",
description: "Mumbai Airport Cab offers Mumbai to Jalgaon Innova Cab service with spacious seating, comfortable AC interiors, and premium travel for families and groups."
},
{
name: "Mumbai to Jalgaon Ertiga Cab",
description: "Book Mumbai to Jalgaon Ertiga Cab for economical family travel with comfortable seating, professional drivers, and affordable pricing."
},
{
name: "Mumbai to Dhule Cab Booking",
description: "Mumbai Airport Cab offers Mumbai to Dhule Cab Booking with instant confirmation, premium vehicles, professional chauffeurs, and convenient travel options for every requirement."
},
{
name: "Mumbai to Dhule Cab",
description: "Book Mumbai to Dhule Cab with Mumbai Airport Cab for safe, comfortable, and affordable travel with clean AC vehicles and experienced drivers."
},
{
name: "Mumbai to Dhule Taxi",
description: "Mumbai Airport Cab provides Mumbai to Dhule Taxi service with flexible pickup options, affordable fares, and dependable transportation for families and business travellers."
},
{
name: "Mumbai to Dhule Taxi Fare",
description: "Get affordable Mumbai to Dhule Taxi Fare with Mumbai Airport Cab featuring transparent pricing, no hidden charges, and multiple vehicle options."
},
{
name: "Mumbai to Dhule Cab Service",
description: "Mumbai Airport Cab offers Mumbai to Dhule Cab Service with Sedan, Ertiga, Innova Crysta, SUV, and luxury vehicles for one way and round trip travel."
},
{
name: "Mumbai to Dhule Outstation Cab",
description: "Book Mumbai to Dhule Outstation Cab for convenient long-distance travel with professional chauffeurs, comfortable vehicles, and customized travel packages."
},
{
name: "Mumbai to Dhule One Way Cab",
description: "Travel with Mumbai to Dhule One Way Cab service featuring fixed rates, AC vehicles, experienced drivers, and hassle-free pickup and drop."
},
{
name: "Mumbai to Dhule SUV Cab",
description: "Choose Mumbai to Dhule SUV Cab for spacious and premium travel with comfortable seating and smooth long-distance transportation."
},
{
name: "Mumbai to Dhule Innova Cab",
description: "Mumbai Airport Cab provides Mumbai to Dhule Innova Cab service with ample luggage capacity, spacious interiors, and premium family travel comfort."
},
{
name: "Mumbai to Dhule Travel Cab",
description: "Book Mumbai to Dhule Travel Cab with Mumbai Airport Cab for business trips, family journeys, sightseeing tours, and leisure travel with reliable chauffeur-driven vehicles."
}
],

tableData: [
["Mumbai to Jalgaon Cab Booking","Mumbai to Jalgaon Cab"],
["Mumbai to Jalgaon Taxi","Mumbai to Jalgaon Taxi Fare"],
["Mumbai to Jalgaon Cab Fare","Cab from Mumbai to Jalgaon"],
["Mumbai to Jalgaon Car Rental","Mumbai to Jalgaon One Way Cab"],
["Mumbai to Jalgaon Round Trip Cab","Mumbai to Jalgaon Outstation Cab"],
["Mumbai to Jalgaon Taxi Service","Mumbai to Jalgaon SUV Cab"],
["Mumbai to Jalgaon Innova Cab","Mumbai to Jalgaon Ertiga Cab"],
["Mumbai to Dhule Cab Booking","Mumbai to Dhule Cab"],
["Mumbai to Dhule Taxi","Mumbai to Dhule Taxi Fare"],
["Mumbai to Dhule Cab Service","Mumbai to Dhule Outstation Cab"],
["Mumbai to Dhule One Way Cab","Mumbai to Dhule SUV Cab"],
["Mumbai to Dhule Innova Cab","Mumbai to Dhule Travel Cab"]
],



whychoose: [
{
WhyChooseheading: "Reliable Mumbai to Jalgaon and Dhule Cab Booking",
WhyChoosedescription: "Mumbai Airport Cab Service provides dependable Mumbai to Jalgaon and Dhule Cab Booking for business travelers, families, tourists, students, and professionals seeking comfortable long-distance travel."
},
{
WhyChooseheading: "Convenient Travel Across North Maharashtra",
WhyChoosedescription: "Our cab service offers hassle-free connectivity between Mumbai, Jalgaon, and Dhule for personal visits, business travel, educational purposes, and family functions."
},
{
WhyChooseheading: "Perfect for Business and Corporate Travel",
WhyChoosedescription: "Professionals frequently choose our cab service for meetings, industrial visits, corporate events, and official travel requirements in Jalgaon and Dhule."
},
{
WhyChooseheading: "Wide Range of Vehicle Options",
WhyChoosedescription: "Customers can select Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles according to passenger count and travel preferences."
},
{
WhyChooseheading: "One-Way and Round Trip Facilities",
WhyChoosedescription: "Whether you require a one-way transfer, same-day return, round trip, or customized travel itinerary, we provide flexible booking options."
},
{
WhyChooseheading: "Pickup Available Across Mumbai",
WhyChoosedescription: "Doorstep pickup services are available from Mumbai Airport, Navi Mumbai, Thane, Andheri, Borivali, Dadar, Bandra, Powai, and nearby locations."
},
{
WhyChooseheading: "Safe and Professional Drivers",
WhyChoosedescription: "Our trained drivers and regularly maintained vehicles ensure safe, comfortable, and stress-free travel throughout the journey."
},
{
WhyChooseheading: "Suitable for Families and Group Travelers",
WhyChoosedescription: "From individual travelers to large groups, we offer suitable vehicle options for family visits, vacations, business travel, and special occasions."
}
]
};

const faqData = [
{
question: "Why do travelers book Mumbai to Jalgaon and Dhule Cabs?",
answer: "Jalgaon and Dhule are important commercial, educational, agricultural, and business centers that attract travelers for various personal and professional reasons."
},
{
question: "Can I book a one-way cab from Mumbai to Jalgaon or Dhule?",
answer: "Yes, one-way cab services are available along with round-trip and customized travel packages."
},
{
question: "Which vehicle is suitable for Mumbai to Jalgaon or Dhule travel?",
answer: "Sedan cars, Ertiga, and Innova Crysta are among the most preferred options due to their comfort and spacious seating."
},
{
question: "Are same-day return trips available?",
answer: "Yes, customers can choose same-day return travel depending on their schedule and travel requirements."
},
{
question: "Can business professionals use this service regularly?",
answer: "Yes, many corporate travelers and executives use our Mumbai to Jalgaon and Dhule Cab Service for official travel and meetings."
},
{
question: "Do you provide Tempo Travellers for group travel?",
answer: "Yes, Tempo Travellers and larger vehicles are available for family tours, corporate outings, and group transportation."
},
{
question: "Can customers start the journey from Mumbai Airport?",
answer: "Yes, pickup services are available from Mumbai Airport, railway stations, hotels, offices, and residential locations."
},
{
question: "Is advance reservation recommended for Mumbai to Jalgaon and Dhule travel?",
answer: "Yes, advance booking helps secure preferred vehicles and ensures smooth travel planning."
},
{
question: "Can multiple stops be included during the trip?",
answer: "Yes, customers can customize their journey by adding business locations, tourist attractions, restaurants, or personal stops."
},
{
question: "How can I book a Mumbai to Jalgaon or Dhule Cab?",
answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Mumbai Airport Cab Service."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Mahesh Patil",
feedback:
"I regularly travel from Mumbai to Jalgaon for business purposes, and Mumbai Airport Cab Service consistently provides comfortable vehicles, punctual pickups, and professional drivers.",
rating: 5
},
{
id: 2,
name: "Mrs. Swati Deshmukh",
feedback:
"We booked a Mumbai to Dhule Cab for a family visit. The vehicle was clean, spacious, and the entire journey was smooth and comfortable from start to finish.",
rating: 5
}
];

































   const Images = [
    { place: "/images/keyword/114.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/113.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/112.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/111.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/110.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/109.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/108.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/107.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/106.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/105.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/104.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/103.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/102.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/101.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/100.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/99.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/98.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Dhule-Cab-Booking" },
    { place: "/images/keyword/97.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/96.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/95.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/94.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/93.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/92.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/91.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/90.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
];













const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Mumbai to Jalgaon Cab Booking / Dhule Cab Service",
"image": "https://www.mumbaiairportcabs.com/assets/images/mumbai-to-jalgaon-cab.jpg",
"description": "Book Mumbai to Jalgaon and Dhule cab service for safe, comfortable, and affordable outstation travel. Mumbai Airport Cabs offers reliable taxi service with professional drivers, clean vehicles, transparent pricing, and flexible one-way and round-trip options.",
"brand": {
"@type": "Brand",
"name": "Mumbai Airport Cabs"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.mumbaiairportcabs.com/mumbai-to-jalgaon-cab-booking"
}
};






    return (
        <div>


<Helmet>
  <title>Mumbai to Jalgaon Cab Booking | Dhule Taxi Service | +91 9545731161</title>

<meta
 name="description"
 content="Book Mumbai to Jalgaon and Dhule cab booking at affordable fares. Reliable taxi service with professional drivers, comfortable cars, one-way and round-trip options for safe outstation travel."
/>

<meta
 name="keywords"
 content="mumbai to jalgaon cab booking, mumbai to jalgaon cab, mumbai to jalgaon taxi, mumbai to jalgaon taxi fare, mumbai to jalgaon cab fare, cab from mumbai to jalgaon, mumbai to jalgaon car rental, mumbai to jalgaon one way cab, mumbai to jalgaon round trip cab, mumbai to jalgaon outstation cab, mumbai to jalgaon taxi service, mumbai to dhule cab, dhule cab from mumbai, jalgaon taxi service mumbai, outstation cab mumbai to jalgaon"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>






            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/98.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#1A4160', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Mumbai Airport Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Mumbai Airport Cabs</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mumbai Airport Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919545731161" className="pc-call">+91 9545731161</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919545731161"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919545731161" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@mumbaiairportcabs.com" className="pc-email">
                                            booking@mumbaiairportcabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Mumbai Airport Cabs</strong><br />

                                            SAWANT SADAN 05 Ramachandra cold drinks House,
                                            Near SBI Bank Nehru Road Opp Noble Medical,
                                            Vile Parle East Mumbai, 400057
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaitojalgaoncabbooking;